import { queryPremiumRateForCIUDR as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForCIUDR as calculateRiderPremium } from 'core/service/rider/premium-calculation'

export default {
  calculateRiderPremium,
  queryPremiumRate,
}
